export default __webpack_public_path__ + "static/media/ch.ccee0cae.svg";